// Informs user of potential network connectivity issues
// uses Notifications banner 

// Dependencies
import { useEffect, useCallback, useState } from 'react';

// Hooks
import { useNotifications } from 'hooks/useNotifications';

// Check network status
function useNetwork() {
  const [status, setStatus] = useState(navigator.onLine);

  const { addNotification, removeNotification } = useNotifications();

  const Notification = {
    Network: 'Network'
  };

  // Online event handler
  const handleOnline = useCallback(
    () => {
      setStatus(true);
    },
    [setStatus]
  );

  // Offline event handler
  const handleOffline = useCallback(
    () => {
      setStatus(false);
    },
    [setStatus]
  );

  // Register online/offline event handler
  useEffect(
    () => {
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);

      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    },
    [handleOnline, handleOffline]
  );

  useEffect(
    () => {
      if (!status) {
        addNotification({
          type: Notification.Network,
          message: 'Network issues detected. Please check your network connection.'
        });
      } else {
        removeNotification({
          type: Notification.Network
        })
      }
    },
    [status, addNotification, removeNotification]
  );

  return { status }
}

export { useNetwork };